// extracted by mini-css-extract-plugin
export default {"header":"Register_header__ZFfJz"};